import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const VideosList: React.FC<Props> = ({ }: Props) => {
    return (
        <BooksList
            category_label='วีดีโอ'
            category_path={routeName.e_library.video}
            category_pathname_label={routeName.e_library.video_list}
            library_category_name={ELibraryCategory.VIDEO}
            path_detail={routeName.e_library.video_detail}
            allow_shadow={true}
            breakpoints={{
                320: {
                    slidesPerView: 2,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 12,
                },
                480: {
                    slidesPerView: 3,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 14,
                },
                640: {
                    slidesPerView: 3,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 4,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 4,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 18,
                },
                1280: {
                    slidesPerView: 4,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 18,
                },
                1536: {
                    slidesPerView: 4,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 20,
                },
                1920: {
                    slidesPerView: 4,
                    grid: { rows: 2, fill: "row" },
                    spaceBetween: 22,
                },
            }}
        />
    )
}

export default VideosList